<mat-form-field class="autocomplete">
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    placeholder="Pesquisa"
    [attr.aria-label]="label"
    matInput
    [formControl]="formSearch()"
    [matAutocomplete]="auto53"
    (blur)="inputBlur()"
  />
  <mat-autocomplete #auto53="matAutocomplete">
    @for (poll of filteredPolls | async; track poll) {
      <mat-option [value]="poll.title" (click)="checkAddPoll(poll.id)">{{
          poll.title
        }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (form().hasError('required')) {
    <mat-error> {{ labelError }}</mat-error>
  }
</mat-form-field>

